export default __webpack_public_path__ + "static/compassion-37f9c87ef88325c88023e6a2903d3f1b.jpg";